import { defineStore } from 'pinia'
import { ref } from 'vue'
import { cloneDeep } from 'lodash'
import type { ObjectTypeGroup } from '@/entities/Inventory/ObjectSubTypes'

export const useInventObjectTypesGroupModal = defineStore('invent_object_types_group_modal', () => {
  const open = ref(false)

  /** Чистые данные */
  const emptyData: ObjectTypeGroup = {
    id: 0,
    catalog_invent_objects_type_id: 0,
    name: '',
    open: false,
    position: 'APPEND',
    protect: false,
    is_tab: false,
    mode: 'DEFAULT',
    type: 'GROUP',
    list_invent_object_type_id: null,
  }

  const data = ref(cloneDeep(emptyData))

  /**
   * Функция очистки формы
   */
  const clear = () => {
    open.value = false
    data.value = cloneDeep(emptyData)
  }

  return {
    open,
    data,

    clear,
  }
})
